import { render, staticRenderFns } from "./transaction-edit.vue?vue&type=template&id=38efc67e&"
import script from "./transaction-edit.vue?vue&type=script&lang=js&"
export * from "./transaction-edit.vue?vue&type=script&lang=js&"
import style0 from "./transaction-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports